/*! quiz.js
    v0.1 (c) Mircea Piturca
    MIT License
*/
(function Quiz(){
  'use strict';

  var support = getSupport();
  var config = JSON.parse( document.querySelector('[data-quiz-config]').innerHTML );
  var filtersData = Object.freeze( objMap(validate, config.filters) );
  var productData = Object.freeze( config.products );
  var nodes;

  compose(themeEditor, init)();

  function init(){
    nodes = {
      doc: [document],
      track: head(nodeList('.quiz-track')),
      panels: nodeList('.quiz-panel'),
      answers: nodeList('[data-answer-trigger]'),
      controls: nodeList('[data-quiz-index]'),
      showResults: nodeList('[data-show-results]')
    }

    // Answer input select
    nodes.answers.map(partial(addEvent, 
      'change', compose(UIheroUpdate, value, target)
    ));
    
   

    // Show results link click
    nodes.showResults.map(partial(addEvent, 
      'click', compose(UIshowResults, UIupdateResults, filterProducts, mapFilters, selectedFilters, selectedAnswers)
    ));

    // Next|Prev link click
    nodes.controls.map(partial(addEvent, 
      'click', compose(UIgoTo, UIdirection, target, preventDefault)
    ));

    // Question scroll/swipe
    nodes.doc.map(partial(addEvent, 
      'quiz-question-change', compose(UIloadImages, UIgetImages, UIupdateHash, UIhideResults, id, target)
    ));

    // Scrollend listner
    support.IntersectionObserver ? 
      initIntersectionObserver(nodes.track, nodes.panels, scrollEndCallback) : initScrollObserver(nodes.track, scrollEndCallback);
  }

  var publicAPI = {
    goTo: UIgoTo,
    next: UInext,
    prev: UIprev,
    index: UIindex,
    nodes: nodes,
    products: productData,
    filters: filtersData,
  }

  window.SectionsDesign = window.SectionsDesign || {};
  window.SectionsDesign.Quiz = publicAPI;
  return publicAPI;


  // ******************************

  function selectedAnswers() {
    return nodeList('[data-answer-trigger]:checked').map(value);
  }

  function selectedFilters(ids) {
    return flatten(props(ids, filtersData).filter(not(isEmpty)));
  }

  function mapFilters(filters) {
    var fnMap = { price: priceFilter, tag: tagFilter, type: typeFilter, vendor: vendorFilter, option: optionFilter }
    return filters.map(function(filter) {
      return partial(fnMap[filter.type], filter.args);
    });
  }

  function filterProducts(filterFns) {
    return productData.filter(function(product) {
      return allPass(filterFns, product);
    });
  }
  
 
  
  
  function UIhideQuestion(panelId) {

    var firstEightPanels = nodes.slice(0, 7);
    var otherPanels =nodes.slice(7);
    if (panelId !== 1 || panelId !== 2 || panelId !== 3 || panelId !== 4 || panelId !== 5 || panelId !== 6 || panelId !== 7 || panelId !== 8) { 
    //if (panelId !== id(firstEightPanels){ 
     debounce(function(){
       questionPanel.setAttribute('hidden', true);
       otherPanels.setAttribute('hidden', true);
      }, 500)();
    }
    return panelId;
  }
  
  function UIshowQuestion() {
    var answerSelected = nodeList('[data-answer-trigger]:checked').map(value)
    if (panelId === 1) {
      if (answerSelected === "foundation"){
      	nodes.panels[8].removeAttribute("hidden");
        nodes.panels[9].removeAttribute('hidden');
      } 
    
    }
  }

  function UIshowResults() {
    last(nodes.panels).removeAttribute('hidden');
  }

  function UIhideResults(panelId) {
    var resultsPanel = last(nodes.panels);
    if (panelId !== id(resultsPanel)) {
      debounce(function(){
        resultsPanel.setAttribute('hidden', true);
      }, 500)();
    }
    return panelId;
  }

  function UIupdateResults(productArr) {
    var html = productArr.reduce(function(acc, product){
      acc += product.html;
      return acc;
    }, '');

    last(nodes.panels).querySelector('.quiz-main').innerHTML = html;
  }

  function UIheroUpdate(answerId) {
    var index = UIindex();
    var oldImage = document.querySelector('[data-question-index="' + index + '"][data-image-selected]');
    var newImage = document.querySelector('[data-img="' + answerId + '"]');
    (newImage && support.CSSAnimation) ? imageChangeAnimate() : imageChange();

    function imageChangeAnimate() {
      newImage.addEventListener('animationend', imageChange);
      newImage.setAttribute('data-image-animated', true);
      newImage.setAttribute('data-image-selected', true);

      if (oldImage) {
        oldImage.setAttribute('data-image-animated', true);
        oldImage.removeAttribute('data-image-selected', true);
      }
    }

    function imageChange() {
      if(newImage) {
        newImage.setAttribute('data-image-selected', true);
        newImage.removeAttribute('data-image-animated');
        newImage.removeEventListener('animationend', imageChange);
      }

      if (oldImage) {
        oldImage.removeAttribute('data-image-selected');
        oldImage.removeAttribute('data-image-animated');
      }
    }
  }

  function UIindex() {
    var index = Math.round(nodes.track.scrollLeft / nodes.track.getBoundingClientRect().width);
    return clamp(index, 0, nodes.panels.length);
  }

  function UIdirection(element) {
    return Number(attr('data-quiz-index', element));
  }

  function UIgoTo(index) {
    var track = nodes.track;
    var panel = head(nodes.panels);
    var x = track.getBoundingClientRect().width * index;


    if(!answerChosen(`#question-${UIindex()+1}`) && index > UIindex()){
      return false
    }

    (support.scrollBehavior || !support.customProperties) ? nativeScroll() : fallbackScroll();

    function nativeScroll() {
      track.scrollLeft = x;
    }

    function fallbackScroll() {
      track.style.setProperty('--scroll-x', (track.scrollLeft - x) + 'px');
      track.setAttribute('data-scroll-animation', true);
      panel.addEventListener('animationend', endAnimation);
    }

    function endAnimation() {
      panel.removeEventListener('animationend', endAnimation);
      track.removeAttribute('data-scroll-animation');
      nativeScroll();
    }
    return index;
  }

  function UInext() {
    var index = UIindex();
    var nextIndex = clamp((index + 1), 0, nodes.panels.length);
    return UIgoTo(nextIndex);
  }

  function UIprev() {
    var index = UIindex();
    var prevIndex = clamp((index - 1), 0, nodes.panels.length);
    return UIgoTo(prevIndex);
  }

  function UIupdateHash(panelId) {
    var newHash = '#' + panelId;
    var oldHash = window.location.hash;
    var shouldUpdate = not(equals)(newHash, oldHash);

    if (support.pushState && shouldUpdate) history.replaceState(null, null, newHash);
    return panelId;
  }

  function UIgetImages(panelId) {
    return nodeList('#' + panelId + ' [data-img]');
  }

  function UIloadImages(imagesArr) {
    var changeSrcset = partial(attrTransfer, 'data-lazy-srcset', 'srcset');
    var changeSrc = partial(attrTransfer, 'data-lazy-src', 'src');
    return imagesArr.map(changeSrcset).map(changeSrc);
  }

  /* Scroll */
  function scrollEndCallback(entries) {
    if (support.IntersectionObserver) {
      // IntersectionObserver callback
      var inView = entries.filter(function(entry){
        return (Math.round(entry.intersectionRatio) === 1);
      });

      if (inView.length > 0) {
        emitEvent('quiz-question-change', { target: head(inView).target });
      }
    } else {
      // ScrollObserver callback
      emitEvent('quiz-question-change', { target: nodes.panels[UIindex()] });
    }
  }

  function initIntersectionObserver(root, rootNodes, callback) {
    var observer = new IntersectionObserver(callback, { root: root, threshold: 0.5 } );
    rootNodes.map(function(element) {
      observer.observe(element);
    })
  }

  function initScrollObserver(root, callback) {
    var initScroll = debounce(callback, 160);
    addEvent('scroll', initScroll, root);
    root.addEventListener('scroll', initScroll);

    // Init an initial change event to preload the panel images
    emitEvent('quiz-question-change', { target: nodes.panels[UIindex()] });
  }

  /* Validation */
  function validate(filters) {
    return filters.filter(function(filter) {
      var fnMap = { tag: arrValidation, type: arrValidation, vendor: arrValidation, price: priceValidation, option: optionValidation }
      var isValid = fnMap[filter.type];
      return not(isEmpty)(filter.args) && isValid(filter.args);
    })
  }

  function arrValidation(args) {
    return isArray(args);
  }
  
  function priceValidation(args) {
    return isNumber(head(args));
  }

  function optionValidation(args) {
    return isString(head(args)) && isArray(last(args));
  }
  
  /* Filters */
  function tagFilter(args, product) {
    return contains(args, product.tags);
  }
  
  function typeFilter(args, product) {
    return contains(args, product.type);
  }

  function vendorFilter(args, product) {
    return contains(args, product.vendor);
  }

  function priceFilter(args, product) {
    var operator = last(args);
    var n1 = product.price;
    var n2 = head(args);
    return numberComparison(operator, n1, n2);
  }

  function optionFilter(args, product) {
    var filterName = head(args);
    var filterValues = last(args);
    return product.options.some(function(option){
      return equals(option.name, filterName) && contains(option.values, filterValues);
    })
  }

  function numberComparison(operator, n1, n2) {
    if (operator === '=') return n1 === n2;
    else if (operator === '<') return n1 < n2;
    else if (operator === '>') return n1 > n2;
    else if (operator === '<=') return n1 <= n2;
    else if (operator === '>=') return n1 >= n2;
  }

  /* Event */
  function addEvent(type, fn, element) {
    element.addEventListener(type, fn);
  }

  function createEvent(eventType, data) {
    return new CustomEvent(eventType, { detail: data });
  }

  function emitEvent(eventType, data) {
    document.dispatchEvent(createEvent(eventType, data));
  }

  function preventDefault(evt) {
    evt.preventDefault();
    return evt;
  }

  function target(evt) {
    return (evt.detail && evt.detail.target) ? evt.detail.target : evt.target;
  }

  /* DOM */
  function id(element) {
    return element.id;
  }

  function attr(str, element) {
    return element.getAttribute(str);
  }

  function value(element) {
    return attr('value', element);
  }

  function nodeList(str, root) {
    if (!root) root = document;
    var nodeList = root.querySelectorAll(str);
    return Array.prototype.slice.call(nodeList);
  }

  function attrTransfer(attr1, attr2, element) {
    nodeList('[' + attr2 + ']', element).map(function(el) {
      var newAttr = el.getAttribute(attr1);
      if (newAttr) {
        el.setAttribute(attr2, newAttr);
        el.removeAttribute(attr1);
      }
      return el;
    })
  }
  
  /* Object */
  function equals(a, b) {
    return a === b;
  }

  function keys(obj) {
    return Object.keys(obj);
  }

  function objMap(fn, obj) {
    return keys(obj).reduce(function(acc, key){
      acc[key] = fn(obj[key]);
      return acc;
    }, {});
  }

  function isNumber(arg) {
    return !isNaN(Number(arg));
  }

  function isString(arg) {
    return typeof arg === 'string' && arg.length !== 0;
  }

  function clamp(num, min, max) {
    return num <= min ? min : num >= max ? max : num;
  }

  // Array
  function isArray(arg) {
    return Array.isArray(arg);
  }

  function isEmpty(arr) {
    return flatten(arr).every(function(item){
      return item.length < 0;
    });
  }

  function contains(arr1, arr2) {
    return arr1.some(function(value){
      return arr2.indexOf(value) !== -1;
    });
  }

  function flatten(arr) {
    return arr.reduce(function(acc, val) {
      return isArray(val) ? acc.concat(flatten(val)) : acc.concat(val);
    }, []);
  }

  function last(arr) {
    return arr[arr.length - 1];
  }

  function head(arr) {
    return arr[0];
  }

  function props(arr, obj) {
    return arr.reduce(function(acc, val){
      acc.push(obj[val]);
      return acc;
    }, []);
  }
  
  /* Fn */
  function not(predicate) {
    return function negated() {
      return !predicate.apply(undefined, arguments);
    };
  }

  function allPass(fns, arg) {
    var predicates = fns.map(function(fn) {
      return fn(arg);
    });
    return predicates.indexOf(false) === -1;
  }

  function debounce(fn, wait, immediate) {
    var timeout;
    return function() {
      var context = this;
      var args = arguments;
      var later = function() {
        timeout = null;
        if (!immediate) fn.apply(context, args);
      };
      var callNow = immediate && !timeout;
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
      if (callNow) fn.apply(context, args);
    };
  }

  function partial(fn) {
    var slice = Array.prototype.slice;
    var args = slice.call(arguments, 1);
    return function() {
      return fn.apply(this, args.concat(slice.call(arguments, 0)));
    };
  }

  function compose() {
    var funcs = Array.prototype.slice.call(arguments).reverse();
    return function() {
      return funcs.slice(1).reduce(function(res, fn) {
        return fn(res);
      }, funcs[0].apply(undefined, arguments));
    };
  }

  /* Support */
  function getSupport() {
    return {
      IntersectionObserver: 'IntersectionObserver' in window && 'IntersectionObserverEntry' in window && 'intersectionRatio' in window.IntersectionObserverEntry.prototype,
      CSSAnimation: 'animation' in document.body.style,
      pushState: window.history && window.history.pushState,
      customProperties: window.CSS && CSS.supports('color', 'var(--primary)'),
      scrollBehavior: 'scrollBehavior' in document.body.style
    }
  }

  /* Theme editor */
  function themeEditor() {
    document.addEventListener('shopify:block:select', function(evt) {
      publicAPI.goTo(config.blocks[evt.detail.blockId]);
    });

    document.addEventListener('shopify:section:load', function() {
      document.querySelector('.quiz-track').style.scrollBehavior = 'initial';
      init();
    });
  }

})();

  //sends email, password, and quiz answers to ec2 linux machine, which puts it into the SQL database
  async function sendQuizData() {  
    
  	const quizFormData = new FormData( document.getElementById("quiz-form") );  
    
    
    //add data from q26 and q28 manually
    //@ is used as a delimiter, format is type@brand@name
    //description is sent as part of the name, product name and desc are separated by '|'
    $.each($("#question-26 .product-selected-name"), function (index, prod) {
    
      let str = `${$(prod).attr("data-type")}@${$(prod).attr("data-brand")}@${$(prod).text()}|${$(prod).attr("data-desc")}`;
      
                                        
      quizFormData.append("answer-for-question-26[]", str);
      
    });

    $("#question-28 .product-selected-name").each(function (index, prod) {
    
      let str = `${$(prod).attr("data-type")}@${$(prod).attr("data-brand")}@${$(prod).text()}|${$(prod).attr("data-desc")}`;
                                        
      quizFormData.append("answer-for-question-28[]", str);
      
    });
    
    
    var request_object = {};
    quizFormData.forEach(function(value, key){
      request_object[key] = value;
    });
    

    request_object['shareable_link'] = `https://renzoebox.com/pages/quiz/?type=results&${new URLSearchParams(request_object)}`
    request_object['date'] = new Date().toLocaleDateString('en-US')

    console.log(request_object)
    fetch(
      'https://renzoeboxquiz.gentian.workers.dev/',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body:  JSON.stringify([request_object]),
          mode: 'no-cors'
        }
      )
      .then(response => {
        if(response){
          document.querySelector('#quiz-form').style.display =  'none'
          document.querySelector('#results').style.display = 'block'
          console.log(response)
        }
      });


    }

  function formDeserialize(form, data) {
      const entries = (new URLSearchParams(data)).entries();

      for(const [key, val] of entries) {
          const input = form.elements[key];
         
          if(input){

            if(input.length){
              input.forEach(e => {
                if(e.value == val) {
                  e.checked = true
                }
                e.readOnly = true;
                e.disabled = true;
              })
            }

            switch(input.type) {
              case 'checkbox': input.checked = !!val; break;
              default:         input.value = val;     break;
            }
            if(key == 'selfie'){
              sourceSelfieImage(val)
            }
          }
         
      }

  }
  
  //validate functions make sure user input is in proper format; show an error message if anything is invalid.
  function validateInput( email, password ) {
  	
    let errorMessage = "";
    
    if(email == "") errorMessage += "Please enter an email.\n";
    else if(email.length > 320 ) erorrMessage += "Email cannot be longer than 320 characters.\n";
      
    //regex to check the email's formatting; not perfect, some bad ones might pass through
    else if( !(/^[\w][\w-.]+[\w]@[\w][\w-.]+[\w]$/.test(email)) ) errorMessage += "Invalid email.\n";
    
    if(password == "") errorMessage += "Please enter a password.\n";
    else if(password.length > 128) errorMessage += "Password cannot be longer than 128 characters.\n";
    
    //passwords can be anything; they will be validated for SQL injection in PHP on the server side.
    
    
    //if terms & conditions checkbox has not been checked
    if(!( $("#terms").is(":checked") )) errorMessage += "Please agree to our Terms & Conditions and Privacy Policy.\n";
    
    if(!errorMessage == "") {
      
    	alert(errorMessage);
      
      return false;
    }
    
    return true;
  }

  //if at least one checkbox on this question has been checked, we can move on.  
  function answerChosen(questionID, $that,e) {

    // //go to step with email 
    // console.log($that.classList);
    // if($that.classList.contains('to-loading-screen')){
    //   setTimeout(function(){
    //     document.querySelector('#loading-screen .quiz-control').click();
    //   }, 5000);
    // }
    //question 26 and 28 don't have any way of sending product data yet, so just return true for now

    let message = "Please select at least one answer.";

    if(questionID == "#question-26" || questionID == "#question-28" || questionID == "#question-30") return true;
    
    //special case for question 2
    if(questionID == "#question-2") {
    
      if($(questionID + " .quiz-answer .time-column:checked").length == 1 &&
         $(questionID + " .quiz-answer .color-column:checked").length == 1&&
         $(questionID + " .quiz-answer .coverage-column:checked").length == 1) return true;
      
      message = "Please select one answer from each column.";
      
    }
    else if ( $(questionID + " .quiz-answer > input:checkbox:checked" ).length ||  $(questionID + " .quiz-answer > input:radio:checked" ).length ){ 
      return true;
    }

    else if ( questionID == "#question-29"){ 
      const first_name = document.querySelector('input.answer-firstname');
      if(first_name.value){
        return true
      }
      message = "Please enter your name."; 
    }

    const alert = document.querySelector(`${questionID} .required-alert`);
    
    if(alert) {
      alert.style.display = 'block'
      alert.innerText = message;
    }
   

    
  }

  function doneCallback(e, finish = false){
      const button = e.target;
      button.innerText = 'Sending..';
      sendQuizData();
  }
  
  //Runs 1ST QUESTION ONLY, when next button is clicked; all other questions use only answerChosen()
  function nextButtonClick(questionID, $that) {   
    if ( answerChosen(questionID, $that) ) {    
    	changeNextRedirects(); 
      	return true;
    }
    
    return false;
  
  }
  
  
  function modifyQuestionTotal(t) {
    // num_q is number of questions added
    num_q = t.dataset.addQuestions.split(" ").length;
    checked = t.checked;

    let totals = document.getElementsByClassName('question-total');
    if (checked) 
      for (let total of totals) {total.textContent = parseInt(total.textContent) + num_q;}
    else 
      for (let total of totals) {total.textContent = parseInt(total.textContent) - num_q;}
  }

  function modifyQuestionTotal_Lips(t) {
    num_q = t.dataset.addQuestions.split(" ").length;
    checked = t.checked;

    let totals = document.getElementsByClassName('question-total');
    let lips = document.getElementsByClassName('lips-1');
    let tmp = 0;
    for (let lip of lips) {tmp += lip.checked;}
    if (checked && tmp === 1) 
      for (let total of totals) {total.textContent = parseInt(total.textContent) + num_q;}
    else if (!checked && tmp === 0) 
      for (let total of totals) {total.textContent = parseInt(total.textContent) - num_q;}
  }

  function modifyQuestionTotal_preSelect(t, add) {
    num_q = t.dataset.addQuestions.split(" ").length;

    let totals = document.getElementsByClassName('question-total');
    if (add)
      for (let total of totals) {total.textContent = parseInt(total.textContent) + num_q;}
    else 
      for (let total of totals) {total.textContent = parseInt(total.textContent) - num_q;}
  }

  // Called by question 1 next link
  function changeNextRedirects() {
    let radios = document.querySelectorAll('#question-1 [data-add-questions]:checked');
    // Mandatory questions, including 1 here breaks stuff for some reason
    // Don't forget to update a11y_index total if the number of mand. qs change.
    let shown_qs = ['2', '3', '4', '5', '6', '7', '8', '26', '28', '29', '30', '31']; 
    for (let radio of radios) {
      shown_qs.push(...radio.dataset.addQuestions.split(" "))
    }
    shown_qs = [...new Set(shown_qs)]; // Remove duplicate entries
    shown_qs.sort((a, b) => a - b);

    const questions = document.querySelectorAll('.quiz-panel.indexable')
    questions.forEach(e => {
      const id = e.dataset.qid
      const qIndex = shown_qs.indexOf(id)
      const next = shown_qs[qIndex + 1]
      const prev = shown_qs[qIndex - 1]
      const prev_el = e.querySelector('.quiz-control-prev')
      const next_el = e.querySelector('.quiz-control-next')
      const current_index = e.querySelector('.question-current-index'); 
      current_index.innerText = `${qIndex + 2 }`
      if(qIndex > -1){
        if(next && next_el)  {
          next_el.href = `#`
          next_el.dataset.quizIndex = next - 1

        }

        if(prev && prev_el) {
          
          prev_el.href = `#`
          prev_el.dataset.quizIndex = prev -1
        }
       
      }
    })
  }



  // Select2 v4.1.0
  // Concept: Render select2 fields after all javascript has finished loading
  var initSelect2 = function(){
    // function that will initialize the select2 plugin, to be triggered later
    var renderSelect = function(){
      $('section#formSection select').each(function(){
        $(this).select2({
          'dropdownCssClass': 'dropdown-hover',
          'width': '',
          'minimumResultsForSearch': -1,
        });
      })
    };
    // create select2 HTML elements
    var style = document.createElement('link');
    var script = document.createElement('script');
    style.rel = 'stylesheet';
    style.href = "https://cdn.jsdelivr.net/npm/select2@4.1.0-rc.0/dist/css/select2.min.css";
    script.type = 'text/javascript';
    script.src = "https://cdn.jsdelivr.net/npm/select2@4.1.0-rc.0/dist/js/select2.min.js";
    // trigger the select2 initialization once the script tag has finished loading 
    script.onload = renderSelect;
    // render the style and script tags into the DOM
    document.getElementsByTagName('head')[0].appendChild(style);
    document.getElementsByTagName('head')[0].appendChild(script);
  };

  // Format for options in product select, i.e., the image display and stuff
  function formatEntry(state) {
    if (!state.id) return state.text;
    const q_index = $(state.element).parent().data('question'); // Try optimize lookup out of formatEntry
    // Filtering logic
    const typeVal = $(`#question-${q_index} .single-select2-type option:selected`).text();
    const brandVal = $(`#question-${q_index} .single-select2-brand option:selected`).text();
    if (typeVal && state.type !== typeVal) return null;
    if (brandVal && state.brand !== brandVal) return null;

    const testImage = state.image ?? state.element.dataset.image ?? "https://cultofthepartyparrot.com/parrots/hd/shuffleparrot.gif";
    const temp = state.text.split('|');
    const $state = temp.length == 1 ? $(
      `<span class="single-select2-name-option"><img src="${testImage}" class="img-flag" style="grid-area:a;margin:auto;" />
      <span style="grid-area:b;">${state.text}</span><span style="grid-area:c;">Subtext</span></span>`
    ) : $(
      `<span class="single-select2-name-option"><img src="${testImage}" class="img-flag" style="grid-area:a;margin:auto;" />
      <span style="grid-area:b;">${temp[0]}</span><span style="grid-area:c;font-size:0.75em;">${temp[1]}</span></span>`
    );
    return $state;
  }

  // Add & format for options in product select when put in selected div
  function addEntrySelected(state, q_index) {
    if (!state.id) return state.text;
    const testImage = state.image ?? state.element.dataset.image ?? "https://cultofthepartyparrot.com/parrots/hd/shuffleparrot.gif";
    const temp = state.text.split('|');
    
    //array with type as 0, brand as 1, and name as 2
    const qData = $.map($("#question-" + q_index + " .select2-selection__rendered"), function(item) {
    
    	return $(item).attr("title");
    });
   
    
    const $state = temp.length == 1 ? $(
      `<span class="product-selected"><img src="${testImage}" class="img-flag" style="grid-area:a;margin:auto;" />
<span data-type="${qData[0]}" data-brand="${qData[1]}" data-desc="" class="product-selected-name" style="grid-area:b;">${state.text}</span>
	  <span class="product-selected-desc" style="grid-area:c;">Subtext</span>
      <span class="product-selected-remove" onclick="this.parentElement.remove()">ⓧ</span></span>`
    ) : $(
      `<span class="product-selected"><img src="${testImage}" class="img-flag" style="grid-area:a;margin:auto;" />
<span data-type="${qData[0]}" data-brand="${qData[1]}" data-desc="${temp[1]}" class="product-selected-name" style="grid-area:b;">${temp[0]}</span>
	  <span class="product-selected-desc" style="grid-area:c;font-size:0.75em;">${temp[1]}</span>
      <span class="product-selected-remove" onclick="this.parentElement.remove()">ⓧ</span></span>`
    );
    $(`#${q_index}-products-selected`).append($state);
  }
  

  // Formats text in select after selection
  function formatSelection(state) {
    if (!state.id) return state.text;
    const temp = state.text.split('|');
    return temp.length == 1 ? state.text : temp[0];
  }
  
const sourceSelfieImage = (src) => {
  const selfie_image =  document.querySelector('.selfie-image')
  selfie_image.src = src
  selfie_image.style.display = 'block'
}

jQuery(function($){

    
  initSelect2();
  const form = document.getElementById("quiz-form");
  const search_query = new URLSearchParams(window.location.search)
  if(search_query.has("type", "results")){
    document.querySelector('.quiz-track').classList.replace('quiz-track', 'quiz-track-view');
    formDeserialize(form,search_query);
  }

  // Cloudinary Upload Widget

  var myWidget = cloudinary.createUploadWidget({
    cloudName: 'dcorxad97', 
    uploadPreset: 'cfqhrtef',
    sources: [ 'local', 'camera']
    }, (error, result) => { 
      if (!error && result && result.event === "success") { 
        console.log('Done! Here is the image info: ', result.info); 
        const secure_image_url = result.info.secure_url;
        document.querySelector('input.selfie').value = secure_image_url;
        document.querySelector('#upload_widget').innerText = 'Upload another one'
        sourceSelfieImage(secure_image_url)
      }
    }
  )
  
  document.getElementById("upload_widget").addEventListener("click", function(){
      myWidget.open();
    }, false);

  $(document).find('input[type="checkbox"], input[type="text"]').on('input', function(){
    var template = '';
    if($(this).parent().hasClass('product-brand-and-name')){
      $(this).parent().parent().find('.product-brand-and-name input').each(function(){
        if($(this).val().length){
          if($(this).attr('name') == 'brand'){
            template += 'Brand: '+$(this).val() + ', ';
          } 
          if($(this).attr('name') == 'product'){
            template += 'Name: '+$(this).val() + '   ';
          }
        }
      });
      template = template.trim().replace('   ',';');
    } else {
      $(this).closest('.quiz-content').find('input[type="checkbox"]:checked').each(function(i){
        template += $(this).val()+',';
      });
    }
    $(this).closest('.quiz-content').find('.has-list-values').val(template);      
  });
});
